import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from 'antd';

const types = {
  app: { icon: 'mobile-alt', name: 'App da Kuidare' },
  email: { icon: ['far', 'envelope'], name: 'E-mail' },
  whatsApp: { icon: ['fab', 'whatsapp'], name: 'WhatsApp' }
};

const CampaignEnabledChannels = ({ channelTypes = [] }) => {
  return (
    <div className="gx-flex-row gx-align-items-center gx-flex-nowrap gx-justify-content-center">
      {channelTypes.map((c) => (
        <Tooltip key={c} title={types[c].name}>
          <FontAwesomeIcon
            className="icon gx-mr-2 gx-fs-lg"
            icon={types[c].icon}
          />
        </Tooltip>
      ))}
    </div>
  );
};

export default CampaignEnabledChannels;
